export default __webpack_public_path__ + "static/media/B02.b56834ad.png";